import ModalDrag from 'component/ModaDrag/ModalDrag'
import {
  Button,
  Col,
  Input,
  Pagination,
  Row,
  Table,
  Tabs,
  Tooltip,
  message,
} from 'antd'
import GlobalCss from '@/global.module.less'
import globalStyles from "../../../../common/global-styles/idatacourse-table.module.less"
import React, { useEffect, useRef, useState } from 'react'
import styles from './add-stu-modal.module.less'
import Progress from 'antd/es/progress'
import Dragger from 'antd/lib/upload/Dragger'
import Cookies from 'js-cookie'
import type { UploadProps } from 'antd'
import * as contants from '@/constants/constants'
import { download } from '@/pages/common/utils/util'
import { sendHttpPostRequest } from '@/api/http-request'
import { DownloadOutlined, SearchOutlined, PlusSquareOutlined} from '@ant-design/icons'
import { BACKEND_API_URL, BACKEND_URL } from '@/constants/constants';
import { wrap } from 'module'


interface AddStuModalProps {
  open: boolean
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
  theme: string
  onCancel: () => void
  college_id?: any
  course_id?: any
  actionCallback: () => void
}

export const AddStudentModal = (props: AddStuModalProps) => {
  const {
    open,
    setOpen,
    theme,
    onCancel,
    college_id,
    course_id,
    actionCallback,
  } = props
  const page = useRef(1)
  const pageSize = useRef(10)
  const query = useRef('')
  const [total, setTotal] = useState(0)
  const [collegeStuList, setCollegeStuList] = useState()
  const [tabActivekey, setTabActivekey] = useState('1')
  const [isUploading, setIsUploading] = useState(false)
  const [uploadName, setUploadName] = useState('')
  const [uploadStatus, setUploadStatus] = useState('') // ? uploading done error
  const [uploadPercent, setUploadPercent] = useState<any>(0)

  const [readFileStatus, setReadFileStatus] = useState('') // ? reading done error
  const [readFilePercent, setReadFilePercent] = useState(0)

  const [createUsersStatus, setCreateUsersStatus] = useState('') // ? creating done error
  const [createUsersPercent, setCreateUsersPercent] = useState(0)
  const [fileList, setFileList] = useState([] as any)
  const [filePath, setFilePath] = useState<any>('')
  const [errorMessage, setErrorMessage] = useState('')
  const [selectRowKeys, setSelectRowKeys] = useState([] as any)
  const [selectedRowsContent, setSelectedRowsContent] = useState([] as any)
  
  const order = useRef('') // 排序升序降序
  const order_by = useRef('') // 排序列
  const roleFilters = useRef([]) // 角色过滤选项


  useEffect(() => {
    if (tabActivekey == '1') {
      queryCollegeUser()
    }
    return () => { }
  }, [])


  // 搜索机构用户
  const onSearchCollegeUserValueChange = (event: any) => {
    query.current = event.target.value
  }


  const onSearchCollegeUserBtn = (e: any) => {
    page.current = 1
    queryCollegeUser()
  }
  const queryCollegeUser = ()=>{
    sendHttpPostRequest(
      'course/api/user_query_college_user',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
        college_id: college_id,
        course_id: course_id,
        query: query.current,
        page: page.current,
        pagesize: pageSize.current,
        order: order.current,
        order_by: order_by.current,
        role: JSON.stringify(roleFilters.current),
      },
      (response: any) => {
        message.destroy()
        if (response.code == -100) {
          // 没登录
          sessionStorage.setItem("previousurl",window.location.href )
          document.getElementById('show-login-modal')!.click()
        } else if (response.code == -501) {
          // 没权限
          message.error('权限不足')
        } else if (response.is_ok == true) {
          setCollegeStuList(response.query_list)
          setTotal(response.total_sum)
        } else {
          message.error(response.message)
        }
      }
    )
  }

  // 添加用户到班级

  const addUserToCourse = (user_item_list: any[], singleMode) => {

    const users_:any[]  = []

    user_item_list.forEach((item=>{
      users_.push({user_id:item.user_id, user_role:item.role})
    }))

    let data = {
      user_id_list: JSON.stringify(users_),
      course_id: course_id,
      college_id: college_id,
    }

    sendHttpPostRequest(
      'course/api/teacher_add_course_user',
      data,
      (res: any) => {
        if (res.code == 0) {
          queryCollegeUser()
          if(singleMode == false){
            setSelectRowKeys([])
            setSelectedRowsContent([])
            setOpen(false)
          }
          actionCallback && actionCallback()

          if (singleMode == true){
            message.success('添加成功~')
          }

        } else {
          message.error(res.message)
        }
      }
    )
  }

      // 学生列表表格发生变化
      const onStudentTableChange: any = (
        pagination: any,
        filters: any,
        sorter: any,
        extra: { currentDataSource: []; action: any }
      ) => {
        if (sorter.order) {
          //如果选择了排序列
          order.current = sorter.order
          order_by.current = sorter.field
        }
        if (filters.role) {
          //如果选择了过滤列
          roleFilters.current = filters.role
        } else {
          roleFilters.current = []
        }
  
        page.current = 1
        queryCollegeUser()
      }

      
  // ! 创建用户
  const createUsers = (file_path: any) => {
    setCreateUsersStatus('creating')
    let timeout = setTimeout(() => {
      setCreateUsersPercent(createUsersPercent + 10)
      if (readFilePercent < 100) {
        // 如果还需要继续执行，重新设置定时器
        timeout = setTimeout(() => {
          setCreateUsersPercent(createUsersPercent + 10)
        }, 500)
      }
    }, 500)
    // 取消定时器
    clearTimeout(timeout)
    let data = {
      file_path: file_path,
      course_id: course_id,
      college_id: college_id,
    }
    sendHttpPostRequest(
      'course/api/batch_import_users_by_file_path',
      data,
      (res) => {
        if (res.code == 0) {
          setCreateUsersStatus('done')
          setCreateUsersPercent(100)
        } else if (res.code == -2) {
          setCreateUsersStatus('error')
          setFilePath(res.data.feedback_file_path)
          setErrorMessage(res.msg)
        } else {
          setCreateUsersStatus('error')
          setErrorMessage(res.msg)
        }
      }
    )
  }
  // ! 读取文件
  const readingFile = (file_path: any) => {
    let data = {
      file_path: file_path,
    }

    setReadFileStatus('reading')
    let timeout = setTimeout(() => {
      setReadFilePercent(readFilePercent + 20)
      if (readFilePercent < 100) {
        // 如果还需要继续执行，重新设置定时器
        timeout = setTimeout(() => {
          setReadFilePercent(readFilePercent + 20)
        }, 500)
      }
    }, 500)
    // 取消定时器
    clearTimeout(timeout)

    try {
      sendHttpPostRequest(
        'course/api/check_batch_import_users_file',
        data,
        (res) => {
          if (res.code == 0) {
            setReadFileStatus('done')
            setReadFilePercent(100)
            createUsers(file_path)
            // TODO: 下一步创建用户
          } else if (res.code == -2) {
            setReadFileStatus('error')
            setFilePath(res.data.feedback_file_path)
            setErrorMessage(res.msg)
          } else {
            setReadFileStatus('error')
            setErrorMessage(res.msg)
          }
        }
      )
    } catch (error) {
      setReadFileStatus('error')
    }
  }

  const uploadData = {
    sessionid: Cookies.get('sessionid'),
    sid: Cookies.get('sessionid'),
  }
  const uploadProps: UploadProps = {
    name: 'users_file',
    multiple: false,
    showUploadList: false,
    data: uploadData,
    accept: '.xlsx,.xls',
    fileList: fileList,
    action:
      contants.BACKEND_URL + '/course/api/batch_import_users_upload_file',
    onChange(info) {
      const { status, percent, name } = info.file

      setFileList(info.fileList)
      if (status !== 'uploading') {
      }
      if (status == 'uploading') {
        setIsUploading(true)
        setUploadPercent(percent?.toFixed())
        setUploadName(name)
        setUploadStatus(status)
      }
      if (status === 'done') {
        if (info.file.response.code == 0) {
          message.success(`${info.file.name} 文件上传成功`)
          setUploadStatus(status)
          console.log(info)

          readingFile(info.file.response.data.file_path)
        }
      } else if (status === 'error') {
        setUploadStatus(status)
        message.error(`${info.file.name} 文件上传失败`)
      }
    },
    onDrop(e) {
      console.log('Dropped files', e.dataTransfer.files)
    },
  }

  const downloadTemplate = () => {
    sendHttpPostRequest(
      'course/api/download_batch_import_users_template_xlsx_file',
      {},
      (res) => {
        download(res, 'application/excel;chartset=UTF-8', '用户模板.xlsx')
      },
      { responseType: 'blob' }
    )
  }

  const onModalPageChange = (npage, npageSize) => {
    page.current = npage
    pageSize.current = npageSize
    queryCollegeUser()
    // 请求数据
  }

  const importStuSingle = (r) => {
    addUserToCourse([r], true)
  }

  const ActionRender = (t, r, i) => (
    <Row align={'middle'} justify={'center'}>
      <Tooltip title={'添加'} placement="top">
        <PlusSquareOutlined  onClick={importStuSingle.bind(this, r)} />
      </Tooltip>
    </Row>
  )

  const retryToUpload = () => {
    // TODO: 重新上传
    setFileList([])
    setUploadStatus('')
    setReadFileStatus('')
    setCreateUsersStatus('')
    setReadFilePercent(0)
    setUploadPercent(0)
    setCreateUsersPercent(0)
    setIsUploading(false)
    setFilePath('')
  }

  const stuCols: any = [
    {
      title: '序号',
      dataIndex: 'index',
      key: 'index',
      render: (t, r, i) => pageSize.current * (page.current - 1) + i + 1,
      width: 70,
      ellipsis: true,
    },
    {
      title: '姓名',
      dataIndex: 'name',
      key: 'name',
      align: 'left',
      width: 100,
      ellipsis: true,
      render: (t, r, i) => {
        return (
        <Row align="middle" justify="start" style={{ gap: '5px' }} wrap={false}>
            <Col>
            <img
                className={GlobalCss.avatar}
                src={BACKEND_API_URL + r.avatar}
                alt=""
            />
            </Col>
            <Col>{r.real_name !== ''? r.real_name : t}</Col>
        </Row>
        )
      },
    },
    {
      title: '学号/工号',
      dataIndex: 'number',
      key: 'number',
      width: 120,
      ellipsis: true,
    },
    {
      title: '账号',
      dataIndex: 'phone',
      key: 'phone',
      width: 120,
      align: 'center',
      ellipsis: true,
      render: (t, r, i) => {return r?.register_type == 1 ? r?.phone: r?.email}
    },
    {
      title: '角色',
      dataIndex: 'role',
      key: 'role',
      width: 80,
      align: 'center',
      ellipsis: true,
      filters: [
        {
            text: '学生',
            value: 1,
        },
        {
            text: '教师',
            value: 2,
        },]
        ,
      onFilter: (value:any, record:any) => true,
      render: (t, r, i) => {return r.role_str}
    },
    {
      title: '注册日期',
      dataIndex: 'register_time',
      key: 'register_time',
      width: 120,
      ellipsis: true,
      align: 'center',
      sorter: true,
      sortDirections: ['descend', 'ascend'],
      defaultSortOrder: 'descend',
      render: (t, r, i) => {return t.slice(0,10)}
    },
    {
      title: '操作',
      dataIndex: 'action',
      key: 'action',
     // fixed: 'right',
      width: 80,
      align: 'center',
      render: ActionRender,
    },
  ]

  const addStuModalContent = (
    <div  className={styles.addStudentTabWrapper}  style={{ position: 'relative' }}>
      <Tabs
        activeKey={tabActivekey}
        onChange={(key) => {
          setTabActivekey(key)
        }}
      >
        <Tabs.TabPane tab="从机构添加" key="1">
          <Row align={"middle"} justify={"end"} style={{ marginBottom: "10px" }}>
            <Col>
              <Input
                  onPressEnter={onSearchCollegeUserBtn}
                  placeholder="请输入姓名/账号..."
                  style={{ float: 'left', borderRadius: 20, width: 250, marginTop:-43 }}
                  suffix={<SearchOutlined style={{ color: '#666666' }} />}
                  onChange={onSearchCollegeUserValueChange}
                />

            </Col>
          </Row>
          <div style={{height:430}} className={globalStyles.tableWrapper}>
            <Table
              pagination={false}
              columns={stuCols}
              dataSource={collegeStuList}
              onChange={onStudentTableChange}
              rowSelection={{
                onChange: (selectedRowKeys, selectedRows) => {
                  console.log(selectedRowKeys)

                  setSelectRowKeys(selectedRowKeys)
                  setSelectedRowsContent(selectedRows)
                },
              }}
              rowKey={(record) => record.user_id}
            />
          </div>
        </Tabs.TabPane>
        <Tabs.TabPane tab="从本地导入" key="2">
          <div className={styles.modalContain}>
            <div className={styles.uploadContain}>
              <div className={styles.progressContain} hidden={!isUploading}>
                <Row
                  align={'middle'}
                  justify={'space-between'}
                  style={{
                    height: '40px',
                    borderBottom: '1px solid #eee',
                    marginBottom: '10px',
                  }}
                >
                  <Col>文件名</Col>
                  <Col>状态</Col>
                </Row>
                <div className={styles.progress}>
                  {/* TODO: 上传文件 */}
                  <div>
                    {' '}
                    <Row
                      style={{ width: '100%', gap: '10px' }}
                      align={'middle'}
                    >
                      <Col>
                        <span
                          style={{borderRadius:'50%', color:'#fff', backgroundColor: '#07c160', lineHeight:'22px', width:22, textAlign:'center', display:'inline-block' }}
                        > 1 </span>
                      </Col>
                      <Col>上传文件</Col>
                    </Row>
                    <Row
                      align={'middle'}
                      justify={'space-between'}
                      style={{ height: '40px'}}
                    >
                      <Col>{uploadName}</Col>
                      <Col className={styles.ColFlex}>
                        <div
                          className={
                            uploadStatus == 'done'
                              ? styles.uploadComplete
                              : uploadStatus == 'error'
                                ? styles.uploadError
                                : ''
                          }
                        ></div>
                        {uploadStatus == 'uploading' && (
                          <span
                            style={{ color: '#4285F4' }}
                            className="iconfont icon_zhengzaitingzhi"
                          ></span>
                        )}
                        <span>
                          {uploadStatus == 'uploading'
                            ? '上传中'
                            : uploadStatus == 'done'
                              ? '上传成功'
                              : uploadStatus == 'error'
                                ? '上传失败'
                                : ''}
                        </span>
                      </Col>
                    </Row>
                    <Progress
                      showInfo={false}
                      percent={uploadPercent}
                      status={'active'}
                      strokeColor={'#07c160'}
                    />
                  </div>
                  {/* TODO: 读取文件 */}
                  <div>
                    {' '}
                    <Row
                      style={{ width: '100%', gap: '10px' }}
                      align={'middle'}
                    >
                      <Col>
                        <span
                          style={{ borderRadius:'50%', color:'#fff', backgroundColor: '#07c160',lineHeight:'22px', width:22, textAlign:'center', display:'inline-block'}}
                          
                        >2</span>
                      </Col>
                      <Col>读取文件</Col>
                    </Row>
                    <Row
                      align={'middle'}
                      justify={'space-between'}
                      style={{ height: '40px'}}
                    >
                      <Col>{uploadName}</Col>
                      <Col className={styles.ColFlex}>
                        <div
                          className={
                            readFileStatus == 'done'
                              ? styles.uploadComplete
                              : readFileStatus == 'error'
                                ? styles.uploadError
                                : ''
                          }
                        ></div>
                        {readFileStatus == 'reading' && (
                          <span
                            style={{ color: '#4285F4' }}
                            className="iconfont icon_zhengzaitingzhi"
                          ></span>
                        )}
                        <span>
                          {readFileStatus == 'reading'
                            ? '读取中'
                            : readFileStatus == 'done'
                              ? '读取成功'
                              : readFileStatus == 'error'
                                ? '读取失败'
                                : ''}
                        </span>
                      </Col>
                    </Row>
                    <Progress
                      showInfo={false}
                      percent={readFilePercent}
                      status={'active'}
                      strokeColor={'#07c160'}
                    />
                  </div>
                  {/* TODO: 创建用户 */}
                  <div>
                    {' '}
                    <Row
                      style={{ width: '100%', gap: '10px' }}
                      align={'middle'}
                    >
                      <Col>
                        <span
                          style={{ borderRadius:'50%', color:'#fff', backgroundColor: '#07c160',lineHeight:'22px', width:22, textAlign:'center', display:'inline-block' }}
                        >3</span>
                      </Col>
                      <Col>创建用户</Col>
                    </Row>
                    <Row
                      align={'middle'}
                      justify={'space-between'}
                      style={{ height: '40px'}}
                    >
                      <Col>{uploadName}</Col>
                      <Col className={styles.ColFlex}>
                        <div
                          className={
                            createUsersStatus == 'done'
                              ? styles.uploadComplete
                              : createUsersStatus == 'error'
                                ? styles.uploadError
                                : ''
                          }
                        ></div>
                        {createUsersStatus == 'creating' && (
                          <span
                            style={{ color: '#4285F4' }}
                            className="iconfont icon_zhengzaitingzhi"
                          ></span>
                        )}
                        <span>
                          {createUsersStatus == 'creating'
                            ? '创建中'
                            : createUsersStatus == 'done'
                              ? '创建成功'
                              : createUsersStatus == 'error'
                                ? '创建失败'
                                : ''}
                        </span>
                      </Col>
                    </Row>
                    <Progress
                      showInfo={false}
                      percent={createUsersPercent}
                      status={'active'}
                      strokeColor={'#07c160'}
                    />
                  </div>
                </div>
              </div>

              <div hidden={isUploading} style={{ height: '400px' }}>
                <Dragger {...uploadProps}>
                  <h2 className={styles.importTitle}>
                    导入之前，请先
                    <a
                      onClick={(e) => {
                        e.stopPropagation()
                        e.preventDefault()
                        downloadTemplate()
                      }}
                      type="link"
                      style={{ fontSize: '18px', padding: 0 }}
                    >
                      下载模版
                    </a>
                    ～
                  </h2>

                  <Button style={{textShadow:'none', boxShadow:'none', marginTop: '80px' }} type="primary">
                    上传
                  </Button>
                  <h2>将文件拖到此处，或点击上传</h2>
                  <div className={styles.tip}>
                  本地导入将会自动为未注册用户创建账号，默认密码为
                    <span className={styles.highlight}>123456</span>；已注册用户请从机构添加
                  </div>
                  <span className={styles.tip}>
                  支持xls/xlsx 文件（文件大小不超过10M，文件行数不超过3000行）
                  </span>
                </Dragger>
              </div>
            </div>
            {(uploadStatus == 'error' ||
              readFileStatus == 'error' ||
              createUsersStatus == 'error') && (
                <Row
                  align={'middle'}
                  justify={'space-between'}
                  style={{ width: '100%', padding: '20px 34px' }}
                >
                  <Col className={styles.errorTip}>
                    <span className="iconfont icon-shibai1"></span>
                    {errorMessage}
                  </Col>
                  {filePath && (
                    <Col>
                      <div
                        className={styles.btnBox}
                        onClick={() => {
                          let data = {
                            sessionid: Cookies.get('sessionid'),
                            file_path: filePath,
                          }

                          sendHttpPostRequest(
                            'course/api/download_batch_import_users_feedback_files',
                            data,
                            (res) => {
                              download(
                                res,
                                'application/excel;chartset=UTF-8',
                                (readFileStatus == 'error' ? '读取' : '创建') +
                                '错误反馈数据.xlsx'
                              )
                            },
                            { responseType: 'blob' }
                          )
                        }}
                      >
                        <DownloadOutlined style={{ color: '#999' }} />
                        {/* <span
                        style={{ color: '#999999' }}
                        className="iconfont icon_xiazai_moren"
                      ></span> */}
                      </div>
                    </Col>
                  )}
                </Row>
              )}
          </div>
        </Tabs.TabPane>
      </Tabs>
    </div>
  )
  return (
    <div className={styles.modalDragWrapper}>
    <ModalDrag
      width={800}
      modalTitle={'添加成员'}
      modalContent={addStuModalContent}
      open={open}
      theme={theme}
      onCancel={() => {
        retryToUpload()
        setOpen(false)
      }}
      footer={
        <div>
          {tabActivekey == '1' ? (
            <div>
              <div style={{textAlign:'center', marginBottom:10, height:42}}>
                <Pagination
                  current={page.current}
                  pageSize={pageSize.current}
                  showSizeChanger={false}
                  onChange={onModalPageChange}
                  total={total}
                  hideOnSinglePage
                />
             </div>
              <div style={{textAlign:'center', height:32}}>
                <Button
                  onClick={() => {
                    retryToUpload()
                    setOpen(false)
                  }}
                  style={{width: '64px', padding: '0px' , textShadow:'none', boxShadow:'none'}}
                >
                  取消
                </Button>
                <Button
                  style={{ width: '64px', padding: '0px' ,textShadow:'none', boxShadow:'none'}}
                  type="primary"
                  onClick={() => {
                    try {
                      addUserToCourse(selectedRowsContent, false)
                    } catch (e) { }
                  }}
                >
                  确定
                </Button>
              </div>
            </div>
          ) : uploadStatus ? (
            <Row align="middle" justify="center" style={{ gap: '50px' }}>
              <Col>
                <Button
                  onClick={() => {
                    retryToUpload()
                    setOpen(false)
                  }}
                  style={{ width: '64px', padding: '0px' ,textShadow:'none', boxShadow:'none'}}
                >
                  取消
                </Button>
              </Col>
              {uploadStatus == 'done' &&
                createUsersStatus == 'done' &&
                readFileStatus == 'done' ? (
                <Col>
                  <Button
                    style={{ width: '64px', padding: '0px',textShadow:'none', boxShadow:'none' }}
                    type="primary"
                    onClick={() => {
                      setSelectRowKeys([])
                      setSelectedRowsContent([])
                      setOpen(false)
                      actionCallback && actionCallback()
                    }}
                  >
                    确定
                  </Button>
                </Col>
              ) : (
                <Button
                  disabled={
                    !(
                      uploadStatus == 'error' ||
                      readFileStatus == 'error' ||
                      createUsersStatus == 'error'
                    )
                  }
                  type="primary"
                  onClick={retryToUpload}
                  style={{textShadow:'none', boxShadow:'none'}}
                >
                  重新上传
                </Button>
              )}
            </Row>
          ) : (
            false
          )}
        </div>
      }
    />
    </div>
  )
}

export default AddStudentModal
